// One calendar controls the logo and its matching cursor stars every year.
const monthFormatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/London',
  month: 'numeric',
});
const hour = 60 * 60 * 1000;
let refreshTimer;

function updateSeasonalBranding() {
  const month = Number(monthFormatter.format(new Date()));
  const halloween = month === 9 || month === 10;

  for (const source of document.querySelectorAll('source[data-henry-seasonal-logo]')) {
    const media = halloween ? 'all' : 'not all';
    if (source.media !== media) source.media = media;
  }
  for (const trail of document.querySelectorAll('henry-cursor-sparkles')) {
    trail.dataset.season = halloween ? 'halloween' : 'standard';
  }
}

function refresh() {
  clearTimeout(refreshTimer);
  updateSeasonalBranding();
  // UK month boundaries fall on UTC hour boundaries, including British Summer Time.
  // Recheck open pages at the next hour, without an animation or polling loop.
  refreshTimer = setTimeout(refresh, hour - (Date.now() % hour));
}

refresh();
document.addEventListener('shopify:section:load', updateSeasonalBranding);
document.addEventListener('visibilitychange', () => {
  if (!document.hidden) refresh();
});
window.addEventListener('pageshow', refresh);
window.addEventListener('pagehide', () => clearTimeout(refreshTimer));
